import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { CiMenuKebab } from "react-icons/ci";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {
  MdOutlineStickyNote2,
  MdLabelImportantOutline,
  MdOutlineCancel,
  MdComment,
  MdRepeat,
  MdPerson,
} from "react-icons/md";
import { TbFileInvoice } from "react-icons/tb";
import { FaShippingFast } from "react-icons/fa";
import { useSelector } from "react-redux";
import Tooltip from "../../../../../../../../Components/Tooltip/Tooltip";

export default function CustomMenu({
  row,
  handleTicketOpen,
  setInvoiceModal,
  printDeclaration,
  labelDownloading,
  CircularLoader,
  printLabel,
  handleReShip,
  setConfirmCancel,
  setDriverModal,
  setShipmentStatusModal,
}) {
  const user = useSelector((state) => state.user);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="table_action__wrap">
      <div
        className="table_action__btn"
        onClick={() => {
          handleTicketOpen(row);
        }}
        style={{
          background:
            row?.tickets?.length > 0 &&
            row?.tickets[0]?.created_by == user.id &&
            (row?.tickets[0]?.status == "Open" ||
              row?.tickets[0]?.status == "Dispute" ||
              row?.tickets[0]?.status == "Disputed")
              ? "red"
              : "none",
          color:
            row?.tickets?.length > 0 &&
            row?.tickets[0]?.created_by == user.id &&
            (row?.tickets[0]?.status == "Open" ||
              row?.tickets[0]?.status == "Dispute" ||
              row?.tickets[0]?.status == "Disputed")
              ? "white"
              : "none",
        }}
      >
        <MdComment size={10} />
        Ticket
      </div>
      <div className="table_action__btn" onClick={handleClick}>
        <CiMenuKebab size={10} style={{ marginRight: "2px" }} />
        More
      </div>
      <Menu
        id={`basic-menu-${row.id}`} // Unique ID for each row
        anchorEl={anchorEl}
        open={open}
        size="small"
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": `basic-button-${row.id}`, // Unique ID for each row
          "box-shadow": "none",
        }}
      >
        {/* <MenuItem
          className="boltTable__action_more_btn_label"
          key="edit"
          onClick={() => {
            handleTicketOpen(row);
            handleClose();
          }}
          style={{
            background:
              row?.tickets?.length > 0 &&
              (row?.tickets[0]?.status == "Open" ||
                row?.tickets[0]?.status == "Dispute" ||
                row?.tickets[0]?.status == "Disputed")
                ? "red"
                : "none",
            color:
              row?.tickets?.length > 0 &&
              (row?.tickets[0]?.status == "Open" ||
                row?.tickets[0]?.status == "Dispute" ||
                row?.tickets[0]?.status == "Disputed")
                ? "white"
                : "none",
          }}
        >
          <ListItemIcon>
            <MdComment size={15} />
          </ListItemIcon>
          <ListItemText>Ticket</ListItemText>
        </MenuItem> */}
        <MenuItem
          className="boltTable__action_more_btn_label"
          onClick={() => {
            setInvoiceModal(row?.id);
            handleClose();
          }}
        >
          <ListItemIcon>
            <MdOutlineStickyNote2 size={15} />
          </ListItemIcon>
          <ListItemText>View</ListItemText>
        </MenuItem>
        {row?.single_shipping_invoice && (
          <MenuItem
            className="boltTable__action_more_btn_label"
            key="Declaration"
            onClick={() => {
              printDeclaration(row);
              handleClose();
            }}
            disabled={
              row?.shipment_status?.toLowerCase() === "cancelled" ? true : false
            }
          >
            <ListItemIcon>
              {labelDownloading === "Declaration" + row?.id ? (
                <CircularLoader side={15} />
              ) : (
                <>
                  <TbFileInvoice size={15} />
                  {/* Declaration */}
                </>
              )}
            </ListItemIcon>
            <ListItemText>Declaration</ListItemText>
          </MenuItem>
        )}
        {/* Label button - disabled for oneTimeShipper users if shipment is not approved */}
        {(() => {
          const isOneTimeShipperNotApproved =
            user?.role === "oneTimeShipper" &&
            row?.shipment_type === "oneTimeShipper";
          const isCancelled =
            row?.shipment_status?.toLowerCase() === "cancelled";
          const isDisabled = isCancelled || isOneTimeShipperNotApproved;

          let tooltipText = "";
          if (isOneTimeShipperNotApproved) {
            if (
              row?.is_package_image === "0" ||
              row?.is_package_image === 0 ||
              row?.is_package_image === null ||
              row?.is_package_image === undefined ||
              row?.is_package_image === ""
            ) {
              tooltipText =
                "Please upload package images first. Label will be available after admin approval.";
            } else {
              tooltipText =
                "Label will be available after admin approval of your shipment.";
            }
          } else if (isCancelled) {
            tooltipText = "Cannot download label for cancelled shipment.";
          }

          const menuItem = (
            <MenuItem
              className="boltTable__action_more_btn_label"
              onClick={() => {
                if (!isDisabled) {
                  printLabel(row);
                  handleClose();
                }
              }}
              disabled={isDisabled}
            >
              <ListItemIcon>
                {labelDownloading === "label" + row?.id ? (
                  <CircularLoader size={15} />
                ) : (
                  <>
                    <MdLabelImportantOutline size={15} />
                  </>
                )}
              </ListItemIcon>
              <ListItemText>Label</ListItemText>
            </MenuItem>
          );

          return tooltipText ? (
            <Tooltip title={tooltipText}>{menuItem}</Tooltip>
          ) : (
            menuItem
          );
        })()}
        {handleReShip && (
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              handleReShip(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <MdRepeat size={15} />
            </ListItemIcon>
            <ListItemText>Reship</ListItemText>
          </MenuItem>
        )}
        {setConfirmCancel && (
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setConfirmCancel(row.id);
              handleClose();
            }}
            disabled={
              row?.shipment_status?.toLowerCase() === "cancelled" ? true : false
            }
          >
            <ListItemIcon>
              <MdOutlineCancel size={15} />
            </ListItemIcon>
            <ListItemText>Cancel</ListItemText>
          </MenuItem>
        )}
        {setDriverModal && (
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setDriverModal();
              handleClose();
            }}
            disabled={
              row?.shipment_status?.toLowerCase() === "cancelled" ? true : false
            }
          >
            <ListItemIcon>
              <MdPerson size={15} />
            </ListItemIcon>
            <ListItemText>Select Driver</ListItemText>
          </MenuItem>
        )}
        {setShipmentStatusModal && (
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setShipmentStatusModal(row?.id);
              handleClose();
            }}
            disabled={
              row?.shipment_status?.toLowerCase() === "cancelled" ? true : false
            }
          >
            <ListItemIcon>
              <FaShippingFast size={15} />
            </ListItemIcon>
            <ListItemText>Update Status</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </div>
  );
}
